import { units, Typography, Grid } from '@hbf/dsl';
import { Like2Light } from '@ha/icons';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useIntl } from 'ha/i18n';
import { UserEntity } from 'ha/types/UserEntity';
import { Link } from 'ha/ui.legacy/Link';

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.txb(0, 1, 1),
  },
  icon: {
    fontSize: units.rem(0.75),
    marginRight: units.rem(0.5),
  },
  listingsCount: {
    marginLeft: units.rem(0.3),
  },
}));

interface Props {
  user: UserEntity;
}

const UserCardStats: React.FC<Props> = ({ user }) => {
  const { classes } = useStyles();
  const { T, urlResolver } = useIntl();
  const { completedBookingsCount, listingsCount, entityId } = user;

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={classes.root}
    >
      {completedBookingsCount > 0 ? (
        <Typography.Caption
          fontWeight="bold"
          color="mint"
          data-test-locator="Landlord Card Successful Bookings"
        >
          <Like2Light className={classes.icon} />
          {completedBookingsCount === 1
            ? T('%d successful booking', completedBookingsCount)
            : T('%d successful bookings', completedBookingsCount)}
        </Typography.Caption>
      ) : null}
      {listingsCount > 0 && (
        <div className={classes.listingsCount}>
          <Link
            to={urlResolver.getLinkToUserPage(entityId)}
            data-test-locator="Landlord Card Total Listings"
            skipLangFormat
            noFollow
          >
            {listingsCount === 1
              ? T('%d listing', listingsCount)
              : T('%d listings', listingsCount)}
          </Link>
        </div>
      )}
    </Grid>
  );
};

export { UserCardStats };
